import { useEffect } from 'react';
import { useTranslations } from 'next-intl';
import {
  APIProvider,
  Map,
  ControlPosition,
  useMap,
} from '@vis.gl/react-google-maps';

const googleMapsApiKey = process.env.NEXT_PUBLIC_GOOGLE_MAP_API_KEY;
const defaultZoomLevel = 14;
const minZoomLevel = 11;
const circleRadius = 100;

export const ListingDetailsGoogleMap = (props) => {
  return (
    <APIProvider apiKey={googleMapsApiKey}>
      <GoogleMap {...props} />
    </APIProvider>
  );
};

const GoogleMap = ({ location }) => {
  const map = useMap();
  const t = useTranslations();
  const hasLocation = location?.latitude && location?.longitude;
  const center = hasLocation
    ? {
        lat: Number(location?.latitude),
        lng: Number(location?.longitude),
      }
    : null;

  useEffect(() => {
    if (!map || !hasLocation) return;

    new window.google.maps.Circle({
      strokeColor: '#FF0000',
      strokeOpacity: 0.8,
      strokeWeight: 2,
      fillColor: '#FF0000',
      fillOpacity: 0.35,
      map,
      center,
      radius: circleRadius,
    });

    map.addListener('center_changed', function () {
      const allowedBounds = map.getBounds();
      if (allowedBounds.contains(center)) {
        return;
      }

      map.panTo(center);
    });

    map.addListener('zoom_changed', function () {
      if (map.getZoom() < minZoomLevel) map.setZoom(minZoomLevel);
    });
  }, [map]);

  return hasLocation ? (
    <div className="pt-8 pb-10 border-t border-slate-300 flex flex-col gap-6">
      <h4 className="text-slate-700 text-lg font-semibold tracking-tight">
        {t('apartment.map.title')}
      </h4>

      <div className="h-[480px] rounded-10 overflow-hidden">
        <Map
          defaultCenter={center}
          defaultZoom={defaultZoomLevel}
          disableDefaultUI={true}
          zoomControl={true}
          zoomControlOptions={{
            position: ControlPosition.TOP_RIGHT,
          }}
          streetViewControl={true}
          streetViewControlOptions={{
            position: ControlPosition.TOP_RIGHT,
          }}
        />
      </div>
    </div>
  ) : null;
};

export default ListingDetailsGoogleMap;
